<template>
  <div :id="!this.isIE() ? 'seq_calendrier' : 'ie'">
    <div v-if="!this.isIE()">
      <div class="infos--date">
        <b-link v-b-modal.modal-select-date>
          <span class="encart--sherpa">Sherpa</span>
          <span class="encart--nomMag">{{ nomMagasin }}</span>
        </b-link>
        <b-link v-b-modal.modal-backPortail>
          <span class="d-block w-100 encart--changeDate">{{
            $t("bandeau.changerStation")
          }}</span>
        </b-link>
        <b-link v-b-modal.modal-select-date>
          <h4>
            <i class="far fa-clock"></i>
            {{ modeSelected }}
            <!-- {{ $t('bandeau.dateLivraison') }} -->
          </h4>
          <span class="encart--chosenDate">{{ dateAndHourFormat }}</span>
          <span class="encart--changeDate">{{ $t("bandeau.changer") }}</span>
        </b-link>
      </div>

      <b-modal
        id="modal-backPortail"
        ref="modal-backPortail"
        :title="quitPresta"
        size="xl"
        centered
        scrollable
        @show="loadModal()"
        hide-footer
      >
        <template v-slot>
          <div class="d-block text-center">
            <p>{{ $t("alert.quitPresta") }}</p>
          </div>
          <b-button
            size="xl"
            variant="outline-secondary"
            @click="hideModal()"
            class="m-2"
            >{{ $t("alert.cancel") }}</b-button
          >
          <b-button size="xl" variant="primary" @click="leavePresta()">{{
            $t("alert.accept")
          }}</b-button>
        </template>
      </b-modal>

      <b-modal
        id="modal-select-date"
        ref="modal-select-date"
        :title="formatedMagasinTitle"
        size="xl"
        centered
        scrollable
        static
        :hide-footer="selectedRetrait === null"
        @show="loadModal()"
      >
        <template v-slot:modal-title>
          <div class="modal-title">
            <div class="supermarket-title">{{ formatedMagasinTitle }}</div>
            <div class="sentence-title" v-html="sentenceTitle"></div>
          </div>
        </template>
        <div class="sc-layout">
          <div class="sc-calendar">
            <p v-if="livraisonStation" class="sc-station">
              {{ livraisonStation }}
            </p>
            <MonthGrid
              v-if="currentMonth !== null"
              :month="currentMonth"
              :locale="locale"
              :available="disponibles"
              :disabled-dates="disabledDates"
              :retrait-dates="pictosRetrait"
              :livraison-dates="pictosLivraison"
              :selected="highlightedDate"
              :min-month="minMonth"
              :max-month="maxMonth"
              :labels="monthLabels"
              @select="selectDay"
              @change-month="changeMonth"
            />
            <div class="sc-legend">
              <span>
                <span class="sc-dot sc-dot-retrait"></span>
                {{ $t("infos.retrait.titre") }}
              </span>
              <span v-if="livraisonMagasin">
                <span class="sc-dot sc-dot-livraison"></span>
                {{ $t("infos.livraison.titre") }}
              </span>
            </div>
            <div class="sc-infos">
              <div class="sc-card infos-retrait" v-if="retrait">
                <h5>
                  <img :src="imgurl + 'retrait.png'" alt="" />
                  {{ $t("infos.retrait.titre") }}
                </h5>
                <div v-if="fraisPreparationRetrait !== null">
                  {{ $t("infos.retrait.fraisPrepa") }}
                  <span class="info-bold">{{
                    fraisPreparationRetraitFormated
                  }}</span>
                </div>
                <div v-if="fraisRetrait !== null">
                  {{ $t("infos.retrait.fraisRetrait") }}
                  <span class="info-bold">{{ fraisRetraitFormated }}</span>
                </div>
              </div>
              <div class="sc-card infos-livraison" v-if="livraisonPossibleJour">
                <h5>
                  <img :src="imgurl + 'livraison.png'" alt="" />
                  {{ $t("infos.livraison.titre") }}
                </h5>
                <div v-if="periodeGratuiteStart !== null" class="info-bold">
                  {{ periodeGratuiteFormated }}
                </div>
                <div v-if="fraisPreparationLivraison !== null">
                  {{ $t("infos.livraison.fraisPrepa") }}
                  <span class="info-bold">{{
                    fraisPreparationLivraisonFormated
                  }}</span>
                </div>
                <div v-if="fraisLivraison !== null">
                  {{ $t("infos.livraison.fraisLivraison") }}
                  <span class="info-bold">{{ fraisLivraisonFormated }}</span>
                </div>
                <div v-if="livraisonGratuiteDes !== null">
                  {{ $t("infos.livraison.freeDeliveryFrom") }}
                  <span class="info-bold">{{ livraisonGratuiteDesFormated }}</span>
                </div>
                <div v-if="montantMinimumPourLivraison !== null">
                  {{ $t("infos.livraison.minimumLivraison") }}
                  <span class="info-bold">{{
                    montantMinimumPourLivraisonFormated
                  }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="sc-side">
            <button
              type="button"
              class="bouton-drive"
              v-if="orderToday"
              @click="goToToday"
            >
              <img :src="imgurl + 'drive.png'" alt="" />
              <span>
                <b>{{ $t("calendrier.bouton.txt") }}</b>
                <span
                  class="drive-last-horaire"
                  v-if="driveLastHoraireRetrait !== null"
                >
                  {{ dernierHorairePossibleDrive }}
                </span>
              </span>
            </button>
            <p v-if="clickedDate === null" class="sc-placeholder">
              {{ $t("calendrier.choixJour") }}
            </p>
            <div
              v-if="clickedDate !== null"
              class="sc-day-summary"
              ref="resume-date"
            >
              <h2
                id="resume-date"
                class="resume-date"
                v-html="clickedDateFormated"
              ></h2>
              <p class="description-horaire" v-if="selectedDate.length !== 0">
                {{ $t("calendrier.click.sentence") }}
              </p>
              <p v-if="errorMessage.length !== 0" class="sc-error">
                {{ errorMessage }}
              </p>
              <div v-if="selectedDate.length !== 0" class="sc-slots">
                <SlotPicker
                  mode="retrait"
                  :title="titreHoraireRetrait"
                  :icon="imgurl + 'retrait.png'"
                  :hours="horaires.all"
                  :available="horaires.retrait"
                  :selected="selectedRetrait === true ? selectedHoraire : null"
                  :enabled="retrait"
                  :empty-message="errorMessageRetrait"
                  @select="handleDateAndHoraire($event, true)"
                />
                <SlotPicker
                  v-if="livraisonMagasin"
                  mode="livraison"
                  :title="titreHoraireLivraison"
                  :icon="imgurl + 'livraison.png'"
                  :hours="horaires.all"
                  :available="horaires.livraison"
                  :selected="selectedRetrait === false ? selectedHoraire : null"
                  :enabled="livraisonPossibleJour"
                  :empty-message="errorMessageLivraison"
                  @select="handleDateAndHoraire($event, false)"
                />
              </div>
            </div>
          </div>
        </div>

        <template v-slot:modal-footer>
          <div class="recapitulatif-selection">
            <div
              class="recapitulatif-selection-texte"
              v-html="recapSentence"
            ></div>
            <button
              type="button"
              class="recapitulatif-selection-bouton"
              @click="submitDate"
            >
              <img :src="imgurl + 'valid.png'" alt="" />
              {{ $t("calendrier.recap.commande.submit") }}
            </button>
          </div>
        </template>
      </b-modal>
    </div>
    <div v-else>
      <h1>{{ $t("ie.title") }}</h1>
      <p>{{ $t("ie.description") }}</p>
      <b-modal
        id="modal-ie"
        ref="modal-ie"
        size="xl"
        centered
        static
        hide-header="true"
        hide-footer="true"
      >
        <p>{{ $t("ie.descriptionModal") }}</p>
        <div class="d-flex flex-wrap justify-content-around align-items-center">
          <a
            href="https://www.microsoft.com/en-us/edge?form=MA13DE&OCID=MA13DE"
            target="_blank"
            class="d-flex flex-column"
          >
            <img
              :src="imgurl + 'edge.png'"
              alt="edge"
              width="75"
              class="d-block mx-auto"
            />
            <span>
              Télécharger
              <br />Microsoft Edge
            </span>
          </a>
          <a
            href="https://www.google.fr/chrome/?brand=CHBD&gclid=EAIaIQobChMIl5ixxO7p5wIVWbvVCh2NqQrWEAAYASAAEgLrc_D_BwE&gclsrc=aw.ds"
            target="_blank"
            class="d-flex flex-column"
          >
            <img
              :src="imgurl + 'chrome.png'"
              alt="chrome"
              width="75"
              class="d-block mx-auto"
            />
            <span>
              Télécharger
              <br />Google Chrome
            </span>
          </a>
          <a
            href="https://www.mozilla.org/fr/firefox/new/"
            target="_blank"
            class="d-flex flex-column"
          >
            <img
              :src="imgurl + 'firefox.png'"
              alt="firefox"
              width="75"
              class="d-block mx-auto"
            />
            <span>
              Télécharger
              <br />Mozilla Firefox
            </span>
          </a>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
var moment = require("moment");
import MonthGrid from "../../shared/MonthGrid.vue";
import SlotPicker from "../../shared/SlotPicker.vue";
import { monthOf, addMonths } from "../../shared/dates";
import axios from "axios";

export default {
  name: "app",
  components: {
    MonthGrid,
    SlotPicker,
  },
  props: {
    locale: String,
    imgurl: String,
    shop: String,
    shopUrl: String,
    cookieDate: String,
    token: String,
    nomMagasin: String,
    retraitChoosen: String,
    livraison: String,
  },
  data() {
    return {
      livraisonMagasin: false,
      livraisonStation: "",
      clickedDate: null,
      periodeGratuiteStart: null,
      periodeGratuiteEnd: null,
      errorMessageLivraison: "",
      errorMessageRetrait: "",
      firstDayMonth: null,
      fraisPreparationRetrait: null,
      fraisRetrait: null,
      fraisPreparationLivraison: null,
      fraisLivraison: null,
      livraisonGratuiteDes: null,
      montantMinimumPourLivraison: null,
      driveLastHoraireRetrait: null,
      hover: false,
      orderToday: false,
      errorMessage: "",
      disponibles: [],
      stopLivraison: [],
      stopCommande: [],
      maxCommande: [],
      selectedDate: "",
      selectedRetrait: null,
      selectedHoraire: "",
      currentMonth: null,
      pictosRetrait: [],
      pictosLivraison: [],
      disabledDates: [],
      url: `../module/seq_magasins/`,
      cookieDateData: this.cookieDate,
      stopLivraisonSelected: false,
      retrait: false,
      livraisonPossibleJour: false,
      horaires: {
        all: [
          "8",
          "9",
          "10",
          "11",
          "12",
          "13",
          "14",
          "15",
          "16",
          "17",
          "18",
          "19",
          "20",
        ],
        retrait: [],
        livraison: [],
      },
    };
  },
  computed: {
    highlightedDate: function () {
      if (this.clickedDate !== null) {
        return this.clickedDate;
      }
      return this.cookieDateData ? this.cookieDateData.substr(0, 10) : null;
    },
    minMonth: function () {
      return this.disponibles.length ? monthOf(this.disponibles[0]) : null;
    },
    maxMonth: function () {
      return this.disponibles.length
        ? monthOf(this.disponibles[this.disponibles.length - 1])
        : null;
    },
    monthLabels: function () {
      if (this.locale === "fr") {
        return { prev: "Mois précédent", next: "Mois suivant" };
      }
      return { prev: "Previous month", next: "Next month" };
    },
    disponibleLivraison: function () {
      let classes = {
        "col-md-12": true,
      };
      if (this.livraisonMagasin) {
        classes = {
          "col-md-6": true,
          "divider-md": true,
        };
      }
      return classes;
    },
    titreHoraireRetrait: function () {
      return (
        this.$t("horaires.titre.horaires") +
        ' <strong class="titre-mode">' +
        this.$t("horaires.titre.retrait") +
        "</strong>"
      );
    },
    titreHoraireLivraison: function () {
      return (
        this.$t("horaires.titre.horaires") +
        ' <strong class="titre-mode">' +
        this.$t("horaires.titre.livraison") +
        "</strong>"
      );
    },
    sentenceTitle: function () {
      let sentence = "";
      if (this.locale === "en") {
        sentence =
          '<span class="choice-title">Choose the day</span> for your order';
      }
      if (this.locale === "fr") {
        sentence =
          '<span class="choice-title">Choix du jour</span> de réception de la commande';
      }
      return sentence;
    },
    clickedDateFormated: function () {
      let format = "";
      if (this.locale === "en") {
        format = "dddd, D MMMM";
      } else if (this.locale === "fr") {
        format = "dddd D MMMM";
      }
      moment.locale(this.locale);
      const clickedDateFormat = moment(this.clickedDate).format(format);
      return (
        this.$t("calendrier.click.order") +
        ' <strong class="date-selected-resume">' +
        this.$t("calendrier.click.for") +
        clickedDateFormat +
        "</strong>"
      );
    },
    periodeGratuiteFormated: function () {
      let format = "";
      if (this.locale === "en") {
        format = "YYYY-MM-DD";
      } else if (this.locale === "fr") {
        format = "DD/MM/YYYY";
      }
      moment.locale(this.locale);
      const dateFormatStart = moment(this.periodeGratuiteStart).format(format);
      const dateFormatEnd = moment(this.periodeGratuiteEnd).format(format);
      return (
        this.$t("calendrier.livraison.periodeGratuite.intro") +
        dateFormatStart +
        this.$t("calendrier.livraison.periodeGratuite.mid") +
        dateFormatEnd
      );
    },
    montantMinimumPourLivraisonFormated: function () {
      return this.montantMinimumPourLivraison + " €";
    },
    livraisonGratuiteDesFormated: function () {
      return this.livraisonGratuiteDes + " €";
    },
    fraisLivraisonFormated: function () {
      let fraisLivraisonStr = this.fraisLivraison + " €";
      if (this.fraisLivraison === 0) {
        fraisLivraisonStr = "Gratuit";
        if (this.locale === "en") {
          fraisLivraisonStr = "Free";
        }
      }
      return fraisLivraisonStr;
    },
    fraisPreparationLivraisonFormated: function () {
      let fraisPreparationLivraisonStr = this.fraisPreparationLivraison + " €";
      if (this.fraisPreparationLivraison === 0) {
        fraisPreparationLivraisonStr = "Offert";
        if (this.locale === "en") {
          fraisPreparationLivraisonStr = "Free";
        }
      }
      return fraisPreparationLivraisonStr;
    },
    fraisRetraitFormated: function () {
      let fraisRetraitStr = this.fraisRetrait + " €";
      if (this.fraisRetrait === 0) {
        fraisRetraitStr = "Gratuit";
        if (this.locale === "en") {
          fraisRetraitStr = "Free";
        }
      }
      return fraisRetraitStr;
    },
    fraisPreparationRetraitFormated: function () {
      let fraisPreparationRetraitStr = this.fraisPreparationRetrait + " €";
      if (this.fraisPreparationRetrait === 0) {
        fraisPreparationRetraitStr = "Offert";
      }
      return fraisPreparationRetraitStr;
    },
    dernierHorairePossibleDrive: function () {
      return (
        this.$t("calendrier.bouton.dernierhoraire.retrait") +
        " : " +
        this.driveLastHoraireRetrait +
        "h00"
      );
    },
    modeSelected: function () {
      let mode = "";
      this.retraitChoosen === "1"
        ? (mode = this.$t("calendrier.recap.commande.retrait"))
        : (mode = this.$t("calendrier.recap.commande.livraison"));
      return mode;
    },
    dateAndHourFormat: function () {
      let format = "";
      if (this.locale === "en") {
        format = "dddd, D MMMM YYYY HH:mm";
      } else if (this.locale === "fr") {
        format = "dddd D MMMM YYYY HH:mm";
      }
      let dateFormat = "";
      moment.locale(this.locale);
      if (this.cookieDateData !== "") {
        dateFormat = moment(this.cookieDateData).format(format);
      }
      return dateFormat;
    },
    recapSentence: function () {
      let mode = "";
      this.selectedRetrait
        ? (mode = this.$t("calendrier.recap.commande.retrait"))
        : (mode = this.$t("calendrier.recap.commande.livraison"));
      return (
        this.$t("calendrier.recap.commande.first") +
        ' <strong class="recap-important">' +
        mode +
        "</strong> " +
        this.$t("calendrier.recap.commande.second") +
        ' <strong class="recap-important">' +
        this.formatedDate +
        " " +
        this.$t("calendrier.recap.commande.third") +
        " " +
        this.selectedHoraire +
        "h</strong>"
      );
    },
    formatedDate: function () {
      let format = "";
      if (this.locale === "en") {
        format = "dddd, D MMMM YYYY";
      } else if (this.locale === "fr") {
        format = "dddd D MMMM YYYY";
      }
      let dateFormat = "";
      moment.locale(this.locale);
      if (this.cookieDateData !== "") {
        dateFormat = moment(this.cookieDateData).format(format);
      }
      return dateFormat;
    },
    formatedMagasinTitle: function () {
      return "Sherpa Supermarché" + " - " + this.nomMagasin;
    },
    quitPresta: function () {
      return this.$t("alert.headerConfirm") + " " + this.nomMagasin;
    },
    selectedDateWithHour: function () {
      return moment(this.selectedDate)
        .add(this.selectedHoraire, "hours")
        .format("YYYY-MM-DD HH:mm:ss");
    },
  },
  methods: {
    goto(refName) {
      // en desktop les créneaux sont à côté du calendrier : pas de scroll
      if (window.matchMedia("(min-width: 992px)").matches) {
        return;
      }
      this.$nextTick(() => {
        const element = this.$refs[refName];
        if (element) {
          element.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      });
    },
    getInformations: function (retrait, date) {
      const vueInstance = this;
      const url = `${this.url}ajax?ajax=true&action=getInfos`;
      if (retrait) {
        axios({
          method: "POST",
          url: url,
          withCredentials: true,
          params: {
            retrait: 1,
            action: "getInfos",
            date: date,
            token: this.token,
            shop: this.shop,
          },
        }).then(function (response) {
          const data = response.data;
          vueInstance.fraisPreparationRetrait = data.fraisPreparationRetrait;
          vueInstance.fraisRetrait = data.fraisRetrait;
        });
      }
      if (!retrait) {
        axios({
          method: "POST",
          url: url,
          withCredentials: true,
          params: {
            retrait: 0,
            action: "getInfos",
            date: date,
            token: this.token,
            shop: this.shop,
          },
        }).then(function (response) {
          const data = response.data;
          vueInstance.fraisPreparationLivraison =
            data.fraisPreparationLivraison;
          vueInstance.fraisLivraison = data.fraisLivraison;
          vueInstance.montantMinimumPourLivraison = data.minimumLivraison;
          vueInstance.livraisonGratuiteDes = null;
          if (typeof data.minimumLivraisonGratuite !== "undefined") {
            vueInstance.livraisonGratuiteDes = data.minimumLivraisonGratuite;
          }
          vueInstance.montantMinimumPourLivraison = null;
          if (typeof data.minimumLivraison !== "undefined") {
            vueInstance.montantMinimumPourLivraison = data.minimumLivraison;
          }
          if (typeof data.periodeLivraisonGratuite !== "undefined") {
            vueInstance.periodeGratuiteStart =
              data.periodeLivraisonGratuite.start;
            vueInstance.periodeGratuiteEnd = data.periodeLivraisonGratuite.end;
          }
        //   vueInstance.livraisonStation = data.zoneLivraison;
        });
      }
    },
    handleDateAndHoraire: function (horaire, retrait) {
      const disponible = retrait
        ? this.isDisponibleRetrait(horaire)
        : this.isDisponibleLivraison(horaire);
      if (disponible) {
        this.selectDateAndHoraire(horaire, retrait);
      }
    },
    goToToday: function () {
      const today = moment().format("YYYY-MM-DD");
      this.currentMonth = monthOf(today);
      this.handleDateClick({ dateStr: today });
    },
    submitDate: function () {
      const vueInstance = this;
      const url = `${this.url}ajax?ajax=true&action=setDateThirdCall`;
      axios({
        method: "POST",
        url: url,
        withCredentials: true,
        params: {
          date: this.selectedDateWithHour,
          action: "setDateThirdCall",
          token: this.token,
          shop: this.shop,
          retrait: this.selectedRetrait,
        },
      }).then(function (response) {
        if (response.data.success) {
          console.log("ok");
          vueInstance.cookieDateData = vueInstance.selectedDateWithHour;
          vueInstance.$refs["modal-select-date"].hide();
          location.reload();
        } else {
          alert("pas ok");
        }
      });
    },
    selectDateAndHoraire: function (horaire, retrait = true) {
      this.selectedRetrait = retrait;
      this.selectedHoraire = horaire;
    },
    isDisponibleLivraison: function (heure) {
      let disponibleBool = false;
      for (let index = 0; index < this.horaires.livraison.length; index++) {
        const horaire = this.horaires.livraison[index];
        if (heure === horaire) {
          disponibleBool = true;
          break;
        }
      }
      return disponibleBool;
    },
    isDisponibleRetrait: function (heure) {
      let disponibleBool = false;
      for (let index = 0; index < this.horaires.retrait.length; index++) {
        const horaire = this.horaires.retrait[index];
        if (heure === horaire) {
          disponibleBool = true;
          break;
        }
      }
      return disponibleBool;
    },
    handleDateClick(info) {
      const vueInstance = this;
      this.selectedRetrait = null;
      this.selectedHoraire = null;
      this.selectedDate = "";
      this.clickedDate = info.dateStr;
      const url = `${this.url}ajax?ajax=true&action=getDatesSecondCall`;
      axios({
        method: "POST",
        url: url,
        withCredentials: true,
        params: {
          date: info.dateStr,
          action: "getDatesSecondCall",
          token: this.token,
          shop: this.shop,
        },
      }).then(function (response) {
        const data = response.data;
        if (data.ok) {
          vueInstance.errorMessage = "";
          vueInstance.errorMessageLivraison = "";
          vueInstance.errorMessageRetrait = "";
          if (data.retrait) {
            vueInstance.retrait = true;
            vueInstance.horaires.retrait = data.horairesRetrait;
            vueInstance.getInformations(true, info.dateStr);
          } else {
            vueInstance.retrait = false;
            if (data.messages !== undefined) {
              vueInstance.errorMessageRetrait = vueInstance.$t(
                "message." + data.messages.retrait[0]
              );
            }
            vueInstance.horaires.retrait = [];
          }
          if (data.livraison) {
            vueInstance.livraisonPossibleJour = true;
            vueInstance.horaires.livraison = data.horairesLivraison;
            vueInstance.getInformations(false, info.dateStr);
          } else {
            vueInstance.livraisonPossibleJour = false;
            if (data.messages !== undefined) {
              vueInstance.errorMessageLivraison = vueInstance.$t(
                "message." + data.messages.livraison[0]
              );
            }
            vueInstance.horaires.livraison = [];
          }
          vueInstance.selectedDate = info.dateStr;
          vueInstance.cookieDateData = info.dateStr;
          vueInstance.goto("resume-date");
        } else {
          vueInstance.errorMessage = vueInstance.$t(
            "message." + data.messages.all[0]
          );
        }
      });
      // this.checkEvents(info);
    },
    hideModal() {
      this.$refs["modal-backPortail"].hide();
    },
    selectDay(date) {
      this.handleDateClick({ dateStr: date });
    },
    changeMonth(delta) {
      this.currentMonth = addMonths(this.currentMonth, delta);
    },
    leavePresta() {
      // on vire les cookies
      const vueInstance = this;
      const url = `${this.url}ajax?ajax=true&action=removeCookies`;
      axios({
        method: "POST",
        url: url,
        withCredentials: true,
        params: {
          action: "removeCookies",
        },
      }).then(function () {
        const baseUrl = window.location.origin;
        let urlRefresh = baseUrl + `/magasins`;
        if (vueInstance.locale === "en") {
          urlRefresh = baseUrl + `/en/stores`;
        }
        return (window.location.href = urlRefresh);
      });
    },
    loadModal() {
      this.loadCalendar();
    },
    loadCalendar() {
      // const url = `${this.url}ajax?ajax=true&shop=${this.shop}&action=getDates`;
      const url = `${this.url}ajax?ajax=true&shop=${this.shop}&action=getDatesFirstCall`;
      axios.get(url).then((response) => {
        this.livraisonStation = response.data.zoneLivraison;
        const dates = response.data;
        this.disponibles = dates.disponible;
        let defaultDate = moment().format("YYYY-MM-DD");
        if (this.disponibles.includes(defaultDate) === false) {
          defaultDate = this.disponibles[0];
        }
        if (dates.stopCommande !== null) {
          this.stopCommande = dates.stopCommande;
        }
        if (dates.stopLivraison !== null) {
          this.stopLivraison = dates.stopLivraison;
        }
        if (dates.maxCommande !== null) {
          this.maxCommande = dates.maxCommande;
        }
        const initialDate = this.cookieDateData || defaultDate;
        if (initialDate) {
          this.currentMonth = monthOf(initialDate);
        }
      });
    },
    isIE() {
      const ua = window.navigator.userAgent;
      const msie = ua.indexOf("MSIE ");
      // eslint-disable-next-line no-useless-escape
      return msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./);
    },
    isOrderTodayPossible() {
      const vueInstance = this;
      const url = `${this.url}ajax?ajax=true&action=checkDateDrive`;
      axios({
        method: "POST",
        url: url,
        withCredentials: true,
        params: {
          date: moment().format("YYYY-MM-DD"),
          action: "checkDateDrive",
          token: this.token,
          shop: this.shop,
        },
      }).then(function (response) {
        const data = response.data;
        vueInstance.orderToday = data.ok;
        vueInstance.driveLastHoraireRetrait = data.dernierHoraireRetrait;
      });
    },
    loadPicto() {
      const vueInstance = this;
      // appel ajax pour avoir les retraits / livraison du mois en cours
      const url = `${this.url}ajax?ajax=true&shop=${this.shop}&action=getPictos`;
      axios({
        method: "GET",
        url: url,
        withCredentials: true,
        params: {
          firstDayMonth: this.firstDayMonth,
          idShop: this.shop,
        },
      }).then(function (response) {
        const responseData = response.data;
        const retraitArr = responseData.retrait;
        const livraisonArr = responseData.livraison;
        vueInstance.pictosRetrait = retraitArr !== null ? retraitArr : [];
        vueInstance.pictosLivraison = livraisonArr !== null ? livraisonArr : [];
      });
    },
  },
  watch: {
    currentMonth: function (month) {
      if (month === null) {
        return;
      }
      this.firstDayMonth = month;
      this.loadPicto();
    },
  },
  mounted() {
    this.livraisonMagasin = Boolean(Number(this.livraison));
    if (!this.isIE()) {
      if (this.cookieDateData === "") {
        this.loadCalendar();
        // this.loadPicto();
        this.$refs["modal-select-date"].show();
      }
      this.isOrderTodayPossible();
    } else {
      this.$refs["modal-ie"].show();
    }
  },
};
</script>

<style lang='scss'>
@import url("https://fonts.googleapis.com/css?family=Open+Sans:400,600,700&display=swap");
@import "../../shared/calendrier.scss";

#seq_calendrier {
  font-family: $sc-font;
}

#modal-ie .modal-body {
  padding: 100px 150px !important;
}

#modal-ie .modal-body a {
  margin-top: 30px;
  color: #000;
}

@media screen and (max-width: 768px) {
  #modal-ie .modal-body {
    padding: 40px 10px !important;
  }
}
</style>
